import { Box } from "@mui/material";
import styled from "styled-components";

export const ProcessContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: 120px;

  @media (max-width: 1200px) {
    justify-content: center;
  }

  @media (max-width: 1040px) {
    flex-direction: column;
    align-items: center;
    gap: 32px;
    margin-bottom: 0px;
  }

  @media (max-width: 600px) {
    align-items: normal;
    padding-left: 14px;
  }
`;
